export const DOMAINS_LIST = {
    TITLE: 'Tracked domains',
    SUBTITLE: 'Certificates that are currently being monitored',
    BTN_ADD: 'Add domain',
    BTN_CHECK: 'Check all certificates',
    BTN_UPGRADE: 'Upgrade required',
    BTN_TRACK: 'Track another domain',
    BTN_EXPORT: 'Export All'
}